import React, { Component, Fragment } from 'react';
import ReportShow from '../show';

export default class Show extends Component {
  render() {
    return (
      <ReportShow title='Customers report'/>
    );
  }
}